var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilWritingGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82331 7.02734L5.03613 7.28299L5.29131 5.49534L9.88732 0.89932C10.0905 0.696163 10.366 0.582031 10.6533 0.582031C10.9406 0.582031 11.2162 0.696163 11.4193 0.89932C11.6225 1.10248 11.7366 1.37802 11.7366 1.66532C11.7366 1.95263 11.6225 2.22817 11.4193 2.43132L6.82331 7.02734Z",
    stroke: "#878E95",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93092 7.08314V10.6941C9.93092 10.8856 9.85484 11.0693 9.7194 11.2048C9.58396 11.3402 9.40027 11.4163 9.20873 11.4163H1.98684C1.7953 11.4163 1.61161 11.3402 1.47617 11.2048C1.34074 11.0693 1.26465 10.8856 1.26465 10.6941V3.47219C1.26465 3.28065 1.34074 3.09696 1.47617 2.96152C1.61161 2.82609 1.7953 2.75 1.98684 2.75H5.59779",
    stroke: "#878E95",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilWritingGrey);
export default __webpack_public_path__ + "static/media/Pencil-Writing-Grey.a3f506e8.svg";
export { ForwardRef as ReactComponent };